/**
 * Bottone unificato dell'app. Sostituisce gli stili inline sparsi.
 *
 * Props:
 *   variant: 'primary' (default) | 'secondary' | 'danger' | 'success' | 'ghost'
 *   size: 'md' (default) | 'sm'
 *   as: elemento/render (es. Link di react-router). Default 'button'.
 *   icon: componente icona (es. da lucide-react) reso a sinistra del testo.
 *   ...rest: passate all'elemento sottostante (onClick, to, type, disabled…).
 */
const VARIANTS = {
  primary:
    'bg-brand-600 text-white hover:bg-brand-700 focus-visible:ring-brand-500 disabled:bg-brand-300',
  secondary:
    'bg-gray-100 text-gray-700 hover:bg-gray-200 focus-visible:ring-gray-400 disabled:opacity-50',
  danger:
    'bg-danger-600 text-white hover:bg-danger-700 focus-visible:ring-danger-500 disabled:bg-danger-300',
  success:
    'bg-success-600 text-white hover:bg-success-700 focus-visible:ring-success-500 disabled:bg-success-300',
  ghost:
    'bg-transparent text-brand-700 hover:bg-brand-50 focus-visible:ring-brand-500 disabled:opacity-50',
}

const SIZES = {
  md: 'px-4 py-2 text-sm',
  sm: 'px-3 py-1.5 text-sm',
}

export default function Button({
  variant = 'primary',
  size = 'md',
  as: Component = 'button',
  icon: Icon,
  className = '',
  children,
  ...rest
}) {
  const base =
    'inline-flex items-center justify-center gap-2 rounded-md font-medium transition-colors ' +
    'focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-1 ' +
    'disabled:cursor-not-allowed'
  const cls = `${base} ${VARIANTS[variant] || VARIANTS.primary} ${SIZES[size] || SIZES.md} ${className}`

  // Per <button> nativo, default type="button" se non specificato.
  const extra =
    Component === 'button' && rest.type === undefined ? { type: 'button' } : {}

  return (
    <Component className={cls} {...extra} {...rest}>
      {Icon && <Icon size={16} aria-hidden="true" />}
      {children}
    </Component>
  )
}
